module.exports = __webpack_public_path__ + "img/sentio-screenshot.fde8ca62.png";